import React from 'react'
import formImg from './images/wpFormImg1.jpg';
import integrationImg from './images/api Integration.png';
import cutomizedimg from './images/customized Img.png';

const What_WhatsAppForm = () => {
    return (
        <section className="py-4 position-relative" 
        style={{
             overflow: 'hidden' ,
             }}
             >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: 30
                }}
            >
                {/* Row left + image right */}
                <div className="wa-forms-row">
                    {/* Left: Heading */}
                    <div className="wa-forms-copy">
                        <h2
                            style={{
                                fontSize: "2.5rem",
                                fontFamily: "Inter",
                                fontWeight: 700,
                                color: "#242121ff",
                                lineHeight: 1.2,
                            }}
                        >
                            Collect data seamlessly
                            <br />
                            with
                            <span style={{ color: '#1DB954' }}>{' '}WhatsApp</span>{' '}Forms
                        </h2>

                        <p
                            className="mt-2"
                            style={{
                                color: "#413e3eff",
                                fontSize: "1.1rem",
                                fontFamily: "Poppins",
                                fontWeight: 300,
                                maxWidth: 780,
                                lineHeight: 1.3,
                            }}
                        >
                            WhatsApp Forms let customers complete forms right inside WhatsApp-no links or web pages. They tap quick buttons or reply short, upload files, give consent, even pay.
                            Submissions are structured and auto-sync to your CRM/Sheets.
                        </p>

                        {/* --- Features with standard icons (under the content) --- */}
                        <div className="wa-features">
                            {/* Feature 1 */}
                            <div className="wa-feature">
                                <span className="wa-icon">
                                    {/* replaced svg with image */}
                                    <img src={integrationImg} alt="API integration" />
                                </span>
                                <div>
                                    <div className="wa-feature-title">API integration</div>
                                    <div className="wa-feature-desc">
                                        Receive submissions and send them to your CRM or tools automatically.
                                        Automate time-consuming tasks effortlessly.
                                    </div>
                                </div>
                            </div>

                            {/* Feature 2 */}
                            <div className="wa-feature">
                                <span className="wa-icon">
                                    {/* replaced svg with image */}
                                    <img src={cutomizedimg} alt="Customizable flows" />
                                </span>
                                <div>
                                    <div className="wa-feature-title">Customizable</div>
                                    <div className="wa-feature-desc">
                                        Design flows for your use cases-from simple FAQs to complex journeys.
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* CTA button with mirror-shine hover */}
                        <div className="wa-cta">
                            <button type="button" className="wa-btn wa-btn-primary">
                                Learn More <span className="wa-arrow">→</span>
                            </button>
                        </div>
                    </div>

                    {/* Right: Image */}
                    <div className="wa-forms-visual">
                        <img
                            src={formImg}
                            alt="WhatsApp form preview"
                            style={{
                                width: '100%',
                                maxWidth: 800,
                                height: 'auto',
                                display: 'block'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* styles */}
            <style>{`
        .wa-forms-row{
          display:flex;
          align-items:flex-start;
          justify-content:space-between;
          gap:48px;
        }
        .wa-forms-copy{ flex:1; }
        .wa-forms-visual{ flex:1; text-align:right; }

        /* features */
        .wa-features{
          margin-top:18px;
          display:flex;
          flex-direction:column;
          gap:16px;
          max-width:720px;
        }
        .wa-feature{
          display:flex;
          align-items:flex-start;
          gap:12px;
        }
        .wa-icon{
          flex:0 0 auto;
          width:40px;
          height:40px;
          border-radius:999px;
          background:#f3f4f6;
          display:grid;
          place-items:center;
          border:1px solid #e5e7eb;
          overflow:hidden;
        }
        .wa-icon img{
          width:22px;
          height:22px;
          object-fit:contain;
          display:block;
          filter: invert(17%) sepia(84%) saturate(1500%) hue-rotate(191deg)
          brightness(88%) contrast(103%);
        }
        .wa-feature-title{
          font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
          font-weight:700;
          color:#111827;
          margin-bottom:2px;
        }
        .wa-feature-desc{
          font-family:Poppins, system-ui, -apple-system, Segoe UI, Roboto, Inter, sans-serif;
          font-size:0.95rem;
          color:#545454;
          line-height:1.35;
        }

        /* CTA button + shine */
        .wa-cta{ margin-top:18px; }
        .wa-btn{
          position:relative;
          display:inline-flex;
          align-items:center;
          gap:10px;
          padding:12px 18px;
          border-radius:12px;
          font-family:Poppins, system-ui, -apple-system, Segoe UI, Roboto, Inter, sans-serif;
          font-weight:600;
          line-height:1;
          cursor:pointer;
          user-select:none;
          white-space:nowrap;
          transition:transform .12s ease, box-shadow .12s ease, background .2s ease;
        }
        .wa-btn:active{ transform:translateY(1px); }
        .wa-btn-primary{
          color:#fff;
          border:none;
          background: #054E91;
          overflow:hidden;
        }
        .wa-btn-primary .wa-arrow{ font-weight:700; }
        .wa-btn-primary::after{
          content:"";
          position:absolute;
          top:-60%;
          left:-50%;
          width:40%;
          height:220%;
          background:linear-gradient(115deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.65) 50%,rgba(255,255,255,0) 100%);
          transform:skewX(-20deg);
          opacity:0;
          pointer-events:none;
        }
        .wa-btn-primary:hover::after{ animation:waShine 900ms cubic-bezier(.25,.8,.25,1) forwards; opacity:1; }
        @keyframes waShine{ 0%{ left:-60%; } 100%{ left:120%; } }

        @media (max-width: 992px){
          .wa-forms-row{ flex-direction:column; gap:28px; }
          .wa-forms-visual{ text-align:center; }
        }
      `}</style>
        </section>
    )
}

export default What_WhatsAppForm

